<template>
  <div class="pt-3">
    <div class="col-12 d-md-none betslip betslip-opener">
      <h4 class="tilte-page" @click="hanleOpenBetslip(isOpen)">
        {{ getTranslatedText(`betslip`) }}
        <div class="badge" v-if="betslips?.length > 0">
          {{ betslips?.length }}
        </div>
      </h4>
    </div>
    <div class="px-1 betslip-wrapper" :class="{ 'betslip-wrapper__open': isOpen, 'betslip-wrapper__closed': !isOpen }">
      <div id="test" ref="targetElement"></div>
      <div class="betslip">
        <h4 class="tilte-page" @click="hanleOpenBetslip(isOpen)">
          {{ getTranslatedText(`betslip`) }}
          <div class="badge" v-if="betslips?.length > 0">
            {{ betslips?.length }}
          </div>
        </h4>
        <div class="row">
          <div class="col-12">
            <ul class="nav nav-tabs">
              <li class="nav-item" v-for="t in tabs" :key="t.id">
                <a class="nav-link" :class="{ 'active': currentTab === t.id }" href="#" @click="changeTab(t.id)">{{
                  getTranslatedText(t.name) }}</a>
              </li>
            </ul>
          </div>
        </div>

        <template v-if="!betslips || betslips?.length == 0">
          <div class="bet-content">
            <div class="betslip-empty">
              {{ getTranslatedText(`betslip is empty`) }}
            </div>
          </div>
        </template>
        <template v-else>
          <div class="bet-content">
            <div class="bet-content__item m-2 p-2" v-for="item in betslips" :key="item.id">
              <div class="header">
                <i class="bi bi-trash trash-icon" @click="removeBetslip(item)"></i>
                {{ getTranslatedText(`fixed`) }} -
                {{ getTranslatedText(item.type) }}
              </div>

              <div class="row">
                <div class="col-10">
                  <b :class="{ 'text-invalid': invalidBetslip.some((x) => x == item.id || x == item.raceId) }">
                    {{ item.horseName }}</b>
                  &nbsp;
                  <i v-if="invalidBetslip.some((x) => x == item.id || x == item.raceId)" class="bi bi-x-lg"
                    :class="{ 'text-invalid': invalidBetslip.some((x) => x == item.id || x == item.raceId), }"></i>
                </div>
                <div class="col-2 d-flex justify-content-end">
                  <b>{{ item.odd }}</b>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  {{ item.countryName }}, - {{ item.raceName }}
                </div>
              </div>

              <div class="row">
                <div class="col-6 d-flex align-items-center">
                  {{ showDate(item.raceTime) }}
                </div>
                <div class="col-6" v-if="currentTab === 'SINGLE'">
                  <div class="d-flex align-items-center p-2">
                    <b class="text-mobile">{{ currencySymbol }}</b>
                    <input @blur="(e) => handleAmountItemChange(e, item)" @keydown="validateStakeInput"
                      class="form-control amount_input" :value="item.amount" />
                  </div>
                </div>
              </div>

              <div class="row d-flex align-items-center" v-if="currentTab === 'SINGLE'">
                <div class="col-6">
                  <b>{{ getTranslatedText(`winning tax`) }}</b>
                </div>
                <div class="col-6">
                  <div class="d-flex justify-content-end p-2">
                    <b>{{ item.winningTax }}</b>
                  </div>
                </div>
              </div>

              <div class="row align-items-center" v-if="currentTab === 'SINGLE'">
                <div class="col-6">
                  <b>{{ getTranslatedText(`possible winnings`) }}</b>
                </div>
                <div class="col-6">
                  <div class="d-flex justify-content-end p-2">
                    <b>{{ item.possibleWinnings }}</b>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="m-2">
            <div class="row" v-if="currentTab === 'MULTIPLE'">
              <p class="m-0 d-flex justify-content-end"><b>{{ getTranslatedText(`total odds`) }}:&nbsp; {{ totalOdds
                  }}</b>
              </p>
            </div>
            <div class="row d-flex align-items-center">
              <div class="col-6">
                <b>{{ getTranslatedText(`total stake`) }}:</b>
              </div>
              <div class="col-6" v-if="currentTab === 'SINGLE'">
                <div class="d-flex justify-content-end p-2">
                  <b> {{ currencySymbol }}</b>&nbsp;
                  <span> {{ totalStake }}</span>
                </div>
              </div>
              <div class="col-6" v-if="currentTab === 'MULTIPLE'">
                <div class="d-flex align-items-center p-2">
                  <b class="text-mobile text-mobile__sum">{{ currencySymbol }}</b>
                  <input @blur="(e) => handleChangeInputStake(e)" @keydown="validateStakeInput" v-model="betsAmount"
                    class="form-control input_sumAmount" />
                </div>
              </div>
            </div>

            <div class="row d-flex align-items-center">
              <div class="col-6">
                <b>{{ getTranslatedText(`winning tax`) }}</b>
              </div>
              <div class="col-6">
                <div class="d-flex justify-content-end p-2">
                  <b>{{ winningTax }}</b>
                </div>
              </div>
            </div>

            <div class="row d-flex align-items-center">
              <div class="col-6">
                <b>{{ getTranslatedText(`possible winnings`) }}</b>
              </div>
              <div class="col-6">
                <div class="d-flex justify-content-end p-2">
                  <b>{{ possibleWinnings }}</b>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div class="m-2">
            <div class="col-12">
              <button class="btn-remove mb-2" @click="removeAllBetslip">{{ getTranslatedText('remove all') }}</button>
              <div v-if="currentTab === 'MULTIPLE' && totalOdds < minMultipleOdds" class="text-infor">
                <i class="bi bi-exclamation-circle"></i>
                {{ getTranslatedText(`The total odds does not meet the minimum value`) }}: &nbsp;{{ minMultipleOdds }}
              </div>

              <div v-if="invalidBetslip.length > 0" class="text-infor">
                <i class="bi bi-exclamation-circle"></i>
                {{ getTranslatedText(`there are conflicting races in your betslip, please revise.`) }}
              </div>

              <div v-if="isValidMaxpayout" class="text-infor">
                <i class="bi bi-exclamation-circle"></i>
                {{ getTranslatedText(`you are reached max payout ${maxPayout} ${currencySymbol}`) }}
              </div>
              <div class="text-warn"
                v-html="getTranslatedWithBreakLineText(`by placing a bet, you accept the terms and conditions applied, bet and limits may varies as per max payout limits of ${maxPayout} ${currencySymbol}`)">
              </div>
            </div>
          </div>

          <div>
            <div class="text-center py-3 booknow w-100"
              :class="{ 'booknow__disable': isLogin && (invalidBetslip.length > 0 || isValidMaxpayout || (currentTab === 'MULTIPLE' && totalOdds < minMultipleOdds)) }">
              <div v-if="!isSubmitData" @click="bookNow()"> {{ !isLogin ? getTranslatedText(`login`) :
                getTranslatedText(`book now`) }}</div>
              <div v-else class="spinner-border text-light" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
            <div class="row m-2">
              <div class="form-check text-center mb-5">
                <label class="form-check-label">
                  <input type="checkbox" class="form-check-input" checked> {{
                    getTranslatedText('accept all odds and line changes') }}
                </label>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import languageMixins from "@/mixins/language/language-mixins";
import utilsMixins from "@/mixins/utils/utils-mixins";
import calculate from "@/mixins/calculate/calculate"
import {
  fixedNumber,
  compareDateTime,
  compareDates,
  formatDateTimeZone,
  isValidBetAmount,
} from "@/utils/utils";
import EventBus from "@/utils/EventBus";
import Page from "@/models/enums/page";
import { alert } from "@/composables/useAlert";
import { modal } from "@/composables/useModal";

export default {
  mixins: [languageMixins, calculate, utilsMixins],
  data() {
    return {
      isLogin: false,
      betDefault: 0,
      betMin: 0,
      betMax: 0,
      maxPayout: 0,
      betsAmount: 0,
      isOpen: false,
      constBet: 0,
      totalStake: 0,
      winningTax: 0,
      possibleWinnings: 0,
      isSubmitData: false,
      isValidMaxpayout: false,
      betslip: null,
      validAmountIds: [],
      currencySymbol: "",
      tabs: [{ id: 'SINGLE', name: "Single" }, { id: 'MULTIPLE', name: "Multiple" }],
      currentTab: 'SINGLE',
      totalOdds: 0,
      minMultipleOdds: 0,
      isFistLoad: true,
      //
      betslips: [],
      invalidBetslip: [],
      lastAmount: 0,
      lastBetAmount: 0,
    };
  },

  watch: {
    '$store.state.betslips': {
      handler(newBetslips) {
        this.handleChangeStake();
        // check invalid
        let invalidOverTime = this.getValidBetslipIdOverTime()
        this.currentTab === 'MULTIPLE' ? this.invalidBetslip = this.getBetslipInvalids() : this.invalidBetslip = []
        if (invalidOverTime.length > 0) this.invalidBetslip.push(...invalidOverTime);
        this.$store.dispatch("addInvalidBet", this.invalidBetslip);
      },
      deep: true
    },
  },
 
  created() {
    this.initDataFromState()
    // handle when init view or refresh page
    this.handleChangeStake();
    // when has a event
    EventBus.$on("add-new-betslip", () => {
      this.betslips =
        this.$store.state.betslips.filter((x) => x.gameType === this.$store.state.settings.currentGame);
    })
    EventBus.$on("open-betslip", (isOpen) => this.hanleOpenBetslip(isOpen));
  },

  mounted() {
    EventBus.$on('refresh', this.handleRefresh)
  },

  beforeUnmount() {
    EventBus.$off("open-betslip");
    EventBus.$off('refresh', this.handleRefresh)
  },

  methods: {
    initDataFromState() {
      this.betMin = this.handleCaluateMinAmount(this.$store.state.settings.betMin, this.$store.state.settings.betDefault);
      this.betMax = this.$store.state.settings.betMax;
      this.betsAmount = this.handleCalculateDefaultAmount(this.$store.state.settings.betMin, this.$store.state.settings.betDefault)
      this.betDefault = this.handleCalculateDefaultAmount(this.$store.state.settings.betMin, this.$store.state.settings.betDefault);
      this.currencySymbol = this.$store.state.settings.currencySymbol
      this.currentTab = this.$store.state.settings.currentTab;
      this.minMultipleOdds = this.$store.state.settings.multiple_bet_minimum_total_odds;
      this.maxPayout = this.$store.state.settings.maxPayout;
      this.isLogin = this.$store.state.isLogin;
      this.betslips =
        this.$store.state.betslips.filter((x) => x.gameType === this.$store.state.settings.currentGame);
      this.invalidBetslip = this.$store.state.invalidBets;
    },

    handleRefresh() {
      this.$forceUpdate();
    },
    redirectPage() {
      this.$router.push({ path: "/history", query: this.$route.query });
      EventBus.$emit("change-active-page", "history")
    },

    changeTab(tabId) {
      this.currentTab = tabId;
      this.handleChangeStake();
      let invalidOverTime = this.getValidBetslipIdOverTime()
      tabId === 'MULTIPLE' ? this.invalidBetslip = this.getBetslipInvalids() : this.invalidBetslip = []
      if (invalidOverTime.length > 0) this.invalidBetslip.push(...invalidOverTime);
      this.$store.dispatch("addInvalidBet", this.invalidBetslip);
      // update to stores
      this.$store.dispatch("updateSettingByName", { name: "currentTab", value: tabId })
    },

    getBetslipInvalids() {
      const raceDuplicate = this.betslips.filter((item, index, array) => {
        return array.some((otherItem, otherIndex) => {
          return index !== otherIndex && item.raceId === otherItem.raceId;
        });
      })

      return raceDuplicate.flatMap(item => {
        if (item.id) {
          return [item.id];
        } else {
          return [];
        }
      });
    },

    showDate(date) {
      let d = formatDateTimeZone(date, this.$store.state.settings.timeZone)
      return compareDates(date, Date.now(), this.$store.state.settings.timeZone) == 0 ? `Today ${d.hour}:${d.minutes}` : `${d.day}-${d.month}-${d.year} ${d.hour}:${d.minutes}`;
    },

    hanleOpenBetslip(isOpen) {
      this.isOpen = !isOpen;
    },

    removeAllBetslip() {
      let gameType = this.$store.state.settings.currentGame ?? "hr";
      this.betslips = this.betslips.filter(x => x.gameType != gameType);
      this.$store.commit('SET_BETSLIP', this.betslips)
    },

    removeBetslip(betslip) {
      let gameType = this.$store.state.settings.currentGame ?? "hr";
      let index = this.betslips.findIndex(x => x.id == betslip.id && x.gameType == gameType)
      if (index > -1) {
        this.betslips.splice(index, 1);
      }
      this.$store.commit('SET_BETSLIP', this.betslips)

      // has change data => calculate state per bet
      this.handleChangeStake();
    },

    async confirm() {
      const path = this.$route.path.split("/");
      const page = path[1];
      // recall api to update odds
      if (page == Page.Today) {
        let payload = {
          isGetAll: true,
        };

        await this.$store.dispatch("fetchData", payload);
      }

      location.reload();
    },

    async bookNow() {
      this.isSubmitData = true;
      if (!this.isLogin) {
        parent.postMessage({ command: 'login' }, '*');
        this.isSubmitData = false;
        this.handleScroll();
        return;
      }

      if (this.betslips.length > 0) {
        // check validate data
        let invalidBets = this.getValidBetslipIdOverTime()
        if (invalidBets.length > 0) {
          this.handleScroll();
          this.$store.dispatch("addInvalidBet", invalidBets);
          alert.showError(this.getTranslatedText(`invalid betslips`));
          this.isSubmitData = false;
          return;
        }

        let bets = [];
        this.betslips.map((bet) => {
          let betType = bet.type == "Place" ? "Place" : "Win";
          let item = {
            amount: bet.amount,
            market: betType,
            selections: [
              {
                field_id: bet.id,
                race_id: bet.raceId,
                odds: bet.odd
              },
            ],
          };
          bets.push(item);
        });

        let payload = {
          type: this.currentTab === 'SINGLE' ? "single" : "multi",
          bets: bets,
          total: this.currentTab === 'SINGLE' ? 0 : this.betsAmount,
        };

        let res = await this.$store.dispatch("bookNow", payload);
        if (res?.data?.status.toLowerCase() == "success") {
          this.initDataFromState()
          alert.showSuccess(res?.data.message);
          modal.show({
            message: this.getTranslatedText('betslip') + ": " + res.data.transaction.id,
            header: this.getTranslatedText('successful bets'),
            title: this.getTranslatedText('bet confirmation'),
            isOk: false,
            textButton: this.getTranslatedText('continue beting'),
            textCustom: this.getTranslatedText('click here to view your history!'),
            onRedirectPage: () => this.redirectPage(),
          });
          // reset betslip
          this.removeAllBetslip()
          // print
          const print_data = JSON.stringify(res.data.print_data)
          parent.postMessage({ action: 'print', type: 'print-horse-betslip', data: print_data }, '*')
          parent.postMessage({ command: 'refreshbalance' }, '*');
        } else {
          if (res?.dataError?.length > 0) {
            this.$store.dispatch("addInvalidBet", res.dataError);
            modal.show({
              message: this.getTranslatedText(res.message),
              isOk: true,
              onConfirm: () => this.confirm(),
            });
          } else {
            alert.showError(res.message ?? this.getTranslatedText("No response data"));
          }
        }
      }

      this.isSubmitData = false;
      this.handleScroll();
    },

    validateMaxPayout() {
      let isValid = +this.maxPayout > 0 && +this.possibleWinnings > 0 && +this.possibleWinnings > +this.maxPayout;
      if (isValid) {
        this.isValidMaxpayout = true;
      } else {
        this.isValidMaxpayout = false;
      }
    },

    handleScroll() {
      parent.postMessage({ command: 'scrollIdTop', id: 'modalPlayHorse' }, '*');
      // check on mobile 
      if (window.innerWidth <= 768) {
        const element = this.$refs.targetElement;
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      } else {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },

    getValidBetslipIdOverTime() {
      let invalidBets = [];
      this.betslips.map((bet) => {
        if (this.invalidBetslip.length > 0 && !this.invalidBetslip.some((x) => x == bet.id) &&
          compareDateTime(bet.raceTime, Date.now(), this.$store.state.settings.timeZone) == -1) {
          invalidBets.push(bet.id);
        }
      });
      return invalidBets;
    },

    handleChangeStake() {
      if (this.betslips.length > 0) {
        let hasSP = this.betslips.some((x) => x.odd === "SP");
        if (!hasSP) {
          this.calculatesStake();
        } else {
          this.calculatesStake();
          this.winningTax = "SP";
          this.possibleWinnings = "SP";
        }
      }
    },

    calculatesStake() {
      switch (this.currentTab) {
        case 'SINGLE':
          this.singleStake()
          break
        case 'MULTIPLE':
          this.multipleStake()
          break
        default:
          break
      }
      // vaidate max payout
      this.validateMaxPayout()
    },

    singleStake() {
      let sumOdds = 0;
      this.betslips.map((bet) => {
        sumOdds += +bet.amount * bet.odd;
      });

      this.totalStake = this.handeCalculateStake();
      let totalWin = +(sumOdds + +this.totalStake);

      this.winningTax = this.handleCalculateWiningTax(totalWin);
      this.possibleWinnings = this.handleCalculatePossibleWinnings(totalWin);
    },

    multipleStake() {
      let mutipOdds = 1;
      this.betslips.map((bet) => {
        mutipOdds *= +bet.odd
      });
      let hasSP = this.betslips.some((x) => x.odd === "SP");
      if (hasSP) {
        this.totalOdds = "SP"
      } else {
        this.totalOdds = fixedNumber(mutipOdds)
      }

      let totalWin = +(mutipOdds * +this.betsAmount) + +this.betsAmount;
      this.winningTax = this.handleCalculateWiningTax(totalWin);
      this.possibleWinnings = this.handleCalculatePossibleWinnings(totalWin);
    },

    handeCalculateStake() {
      let value = this.betslips.reduce(
        (accumulator, currentItem) => {
          return accumulator + +currentItem.amount;
        },
        0
      );
      return fixedNumber(value);
    },

    handleAmountItemChange(e, item) {
      let valueInput = +e.target.value;
      let value = (valueInput >= this.betMin && valueInput <= this.betMax) ? valueInput : this.betDefault
      this.handleUpdateBetslipWhenChangeAmount(value, item)
    },

    handleUpdateBetslipWhenChangeAmount(amount, item) {
      let index = this.betslips.indexOf(item)
      if (index > -1) {
        let totalWin = item.odd == "SP" ? "SP" : item.odd * amount + amount
        this.betslips[index].amount = amount;
        this.betslips[index].winningTax = item.odds == "SP" ? "SP" : this.handleCalculateWiningTax(totalWin)
        this.betslips[index].possibleWinnings = item.odds == "SP" ? "SP" : this.handleCalculatePossibleWinnings(totalWin)
      }

      this.$store.commit('SET_BETSLIP', this.betslips)
      this.handleChangeStake();
    },

    handleChangeInputStake(e) {
      let valueInput = +e.target.value;
      this.betsAmount = (valueInput >= this.betMin && valueInput <= this.betMax) ? valueInput : this.betDefault;
      this.handleChangeStake()
    }
  },
};
</script>

<style lang="scss">
@import "@/public/scss/components/right_bar.scss";
</style>
